import {
  rmPdCtProps,
  rmPdHisProps,
  rmPdSellPriProps,
  rmPdStaProps,
  rmPdStaSearchProps,
} from "interface/rm/crr";
import api from "./api";
import { rmPdHisInfProps } from "interface/rm/rmPdHis";
import { resvProps } from "interface/rm/rsv";
import { IImg, page } from "interface";
import { rmRsvCnlProps } from "interface/rm/rsvCnl";
import { rmPdsProps } from "interface/rm/rmpd";
import {
  opAdInfProsp,
  rmOpDftInfProps,
  rmOpMdfProps,
  rmOpProsp,
} from "interface/rm/op";
import {
  IRmAdInf,
  rmImgMdfIdxProps,
  rmImgModifyProps,
  rmImgRmvProps,
  rmProps,
} from "interface/rm/rm";

// 객실현황
export const rmPdStasApi = async (params: rmPdStaSearchProps) => {
  const res = await api({
    method: "post",
    url: "rmSta/rmPdSta",
    data: params,
  });
  return res;
};

// 객실상품수량변경
export const rmPdCtModifyApi = async (params: rmPdCtProps) => {
  const res = await api({
    method: "post",
    url: "rmSta/rmPdCtModify",
    data: params,
  });

  return res;
};

//객실상품가격변경
export const rmPdSellPriModifyApi = async (params: rmPdSellPriProps) => {
  const res = await api({
    method: "post",
    url: "rmSta/rmPdSellPriModify",
    data: params,
  });
  return res;
};

//객싨상품상태변경
export const rmPdStaModifyApi = async (params: rmPdStaProps) => {
  const res = await api({
    method: "post",
    url: "rmSta/rmPdSellStaModify",
    data: params,
  });

  return res;
};

//객실상품이력조회
export const rmPdHistsApi = async (parmas: Partial<rmPdHisProps>) => {
  const res = await api({
    method: "post",
    url: "rmSta/rmPdHistList",
    data: parmas,
  });

  return res;
};

//객실상품이력상세조회
export const rmPdHisInfApi = async (params: rmPdHisInfProps) => {
  const res = await api({
    method: "post",
    url: "rmSta/rmPdHistDtlInf",
    data: params,
  });

  return res;
};

//객실예약조회
export const rmResvsApi = async (params: Partial<resvProps> & page) => {
  const res = await api({
    method: "post",
    url: "rmResv/rmResvList",
    data: params,
  });

  return res;
};

//객실예약상세조회
export const rmResvInfApi = async (rmPdNo: string) => {
  const res = await api({
    method: "post",
    url: "rmResv/rmResvPdDtl",
    data: { rmPdNo },
  });

  return res;
};

//객실예약취소수수료 조회
export const rmResvCnlFeeAmtApi = async (rmPdNo: { rmPdNo: string }) => {
  const res = await api({
    method: "post",
    url: "rmResv/rmResvCnlFeeAmt",
    data: rmPdNo,
  });

  return res;
};

//객실예약취소
export const rmResvCnlApi = async (rmPdNo: { rmPdNo: string }) => {
  const res = await api({
    method: "post",
    url: "rmResv/cnlRmResv",
    data: rmPdNo,
  });

  return res;
};

//객실예약취소조회
export const rmResvCnlsApi = async (params: Partial<rmRsvCnlProps> & page) => {
  const res = await api({
    method: "post",
    url: "rmResv/rmResvCnlList",
    data: params,
  });

  return res;
};

//객실예약취소상세조회
export const rmResvCnlInfApi = async (params: any) => {
  const res = await api({
    method: "post",
    url: "rmResv/rmResvCnlDtl",
    data: params,
  });

  return res;
};

//객실상품조회
export const rmPdsApi = async (params: Partial<rmPdsProps> & page) => {
  const res = await api({
    method: "post",
    url: "rmPd/rmPdList",
    data: params,
  });

  return res;
};

//객실상품상세조회
export const rmPdInfApi = async (rmPdNo: string) => {
  const res = await api({
    method: "get",
    url: `rmPd/rmPdDtl/${rmPdNo}`,
  });

  return res;
};

//객실상품등록
export const rmPdCreateApi = async (params: any) => {
  const res = await api({
    method: "post",
    url: `rmPd/createRmPd`,
    data: params,
  });

  return res;
};

//객실조회
export const rmsApi = async (params: any) => {
  const res = await api({
    method: "post",
    url: `rm/rmPageList`,
    data: params,
  });

  return res;
};

//객실생성
export const rmCrateApi = async (params: rmProps) => {
  const res = await api({
    method: "post",
    url: "rm/createRm",
    data: params,
  });

  return res;
};

//객실추가정보등록
export const rmAdCreateApi = async (
  // params: Array<IRmAdInf> & { rmNo: string }
  params: { rmNo: string; rmAddInfList: Array<IRmAdInf> }
) => {
  const res = await api({
    method: "post",
    url: "rm/addRmAddInf",
    data: params,
  });
  return res;
};

//객실이미지등록
export const rmImgCrateApi = async (params: {
  rmNo: string;
  rmImgList: Array<IImg>;
}) => {
  const res = await api({
    method: "post",
    url: "rm/addRmImg",
    data: params,
  });

  return res;
};

//객실상세
export const rmInfApi = async (params: { rmNo: string }) => {
  const res = await api({
    method: "post",
    url: "rm/rmDtl",
    data: params,
  });

  return res;
};

//객실상태수정
export const rmuYnUpdateApi = async (params: any) => {
  // const res = await api({
  //   method: ''
  // })
};

//객실기본정보수정
export const rmModifyApi = async (params: any) => {
  const res = await api({
    method: "post",
    url: "rm/rmInfModify",
    data: params,
  });
  return res;
};

//객실이미지 삭제 or 변경 or 순서 변경
export const rmImgModifyApi = async (params: {
  rmNo: string;
  tarRmImgList: Array<Partial<rmImgModifyProps>>;
}) => {
  const res = await api({
    method: "post",
    url: "rm/rmImgModify",
    data: params,
  });
  return res;
};

//객실옵션조회
export const rmOpsApi = async (
  params: Partial<rmOpProsp> & page & { lodNo: string }
) => {
  const res = await api({
    method: "post",
    url: `rmOp/rmOpPageList`,
    data: params,
  });

  return res;
};

//객실옵션상세
export const rmOpInfApi = async (params: { opRgSeq: number; rmNo: string }) => {
  const res = await api({
    method: "post",
    url: "rmOp/rmOpDtl",
    data: params,
  });

  return res;
};

//객실옵션등록
export const rmOpInfCreateApi = async (params: rmOpDftInfProps) => {
  const res = await api({
    method: "post",
    url: "rmOp/createRmOp",
    data: params,
  });

  return res;
};

//객실옵션언어별 추가정보등록
export const rmOdAdInfCreateApi = async (params: opAdInfProsp) => {
  const res = await api({
    method: "post",
    url: "rmOp/createRmOpInf",
    data: params,
  });
  return res;
};
//객실옵션기본정보수정
export const rmOpModifyApi = async (params: rmOpMdfProps) => {
  const res = await api({
    method: "post",
    url: "rmOp/rmOpModify",
    data: params,
  });

  return res;
};
